// FullScreenLoader.jsx
import React from 'react';

const FullScreenLoader = ({ text = 'Loading...' }) => {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1050,
      }}
    >
      <div className="text-center text-white">
        <div
          className="spinner-border text-light"
          role="status"
          style={{ width: '3rem', height: '3rem' }}
        >
          <span className="visually-hidden">{text}</span>
        </div>
        <div className="mt-3">{text}</div>
      </div>
    </div>
  );
};

export default FullScreenLoader;
